/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const CustomGridCellRendererComponent = (params) => {
  const cellValue = params?.api?.getValue(params?.column?.colId, params?.node);
  const DisplayValue = params?.value ? params?.value : cellValue;
  let printPrefixValue = params.colDef.printPrefixValue || '';
  if (params.colDef?.exportOption?.printWithCurrency?.trim() === '$') {
    printPrefixValue = '$';
  }
  const printPostfixValue = params.colDef.printPostfixValue || '';
  if (cellValue === '') {
    return '';
  }
  let value = 0;
  if (DisplayValue?.toString()?.includes('$')) {
    value = parseFloat(DisplayValue?.split('$')[1]?.trim());
  } else {
    value = parseFloat(DisplayValue);
  }
  if (params?.data?.isBottomRow) {
    const pinnedValue = parseFloat(params?.value);
    if (pinnedValue < 0) {
      return (
        <b>
          <span
            style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}
          >
            (
            {`${printPrefixValue} ${Math.abs(
              parseFloat(pinnedValue)
            ).toLocaleString('en-US', {
              minimumFractionDigits: params.colDef.decimalunit || 2,
              maximumFractionDigits: params.colDef.decimalunit || 2,
            })} ${printPostfixValue}`}
            )
          </span>
        </b>
      );
    }
    if (pinnedValue) {
      return (
        <div style={{ textAlign: 'right' }}>
          <b>
            {`${printPrefixValue} ${parseFloat(pinnedValue)?.toLocaleString(
              'en-US',
              {
                minimumFractionDigits: params.colDef.decimalunit || 2,
                maximumFractionDigits: params.colDef.decimalunit || 2,
              }
            )} ${printPostfixValue}`}
          </b>
        </div>
      );
    }
    return (
      <div style={{ textAlign: 'right' }}>
        <b>{`${printPrefixValue} ${
          params.colDef.decimalunit
            ? parseFloat(0).toFixed(params.colDef.decimalunit)
            : '0.00'
        } ${printPostfixValue}`}</b>
      </div>
    );
  }
  if (value < 0) {
    return (
      <span style={{ color: '#eb0000', textAlign: 'right', display: 'inline' }}>
        {` (${printPrefixValue} ${Math.abs(parseFloat(value)).toLocaleString(
          'en-US',
          {
            minimumFractionDigits: params.colDef.decimalunit || 2,
            maximumFractionDigits: params.colDef.decimalunit || 2,
          }
        )}
        ${printPostfixValue})`}
      </span>
    );
  }
  if (value) {
    return (
      <div style={{ textAlign: 'right' }}>{`${printPrefixValue} ${parseFloat(
        value
      )?.toLocaleString('en-US', {
        minimumFractionDigits: params.colDef.decimalunit || 2,
        maximumFractionDigits: params.colDef.decimalunit || 2,
      })} ${printPostfixValue}`}</div>
    );
  }
  return (
    <div style={{ textAlign: 'right' }}>{`${printPrefixValue} ${
      params.colDef.decimalunit
        ? parseFloat(0).toFixed(params.colDef.decimalunit)
        : '0.00'
    } ${printPostfixValue}`}</div>
  );
};
export default CustomGridCellRendererComponent;
